/* eslint-disable no-param-reassign */
import {
  LOGIN_SUCCESS,
  LOGOUT,
  SET_REALM,
  SILENT_LOGIN,
  UPDATE_INCLUDES_DEFAULT,
  UPDATE_NEXWAY_STATE,
} from '../constants/actionTypes';

const initialState = {
  user: null,
  nexwayState: null,
  includesDefault: false,
  realm: null,
};

const Account = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGOUT:
      return initialState;
    case UPDATE_INCLUDES_DEFAULT:
    case SILENT_LOGIN:
    case LOGIN_SUCCESS:
    case UPDATE_NEXWAY_STATE:
      return { ...state, ...payload };

    case SET_REALM:
      return { ...state, realm: payload.realm };

    default:
      return state;
  }
};

export default Account;
